/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IntegrationSettings
 */
export interface IntegrationSettings {
    /**
     * 
     * @type {number}
     * @memberof IntegrationSettings
     */
    max_document_age_days: number;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationSettings
     */
    cprm_ignore_latest_document_date: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationSettings
     */
    aida_download_joined_records?: boolean;
}

/**
 * Check if a given object implements the IntegrationSettings interface.
 */
export function instanceOfIntegrationSettings(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "max_document_age_days" in value;
    isInstance = isInstance && "cprm_ignore_latest_document_date" in value;

    return isInstance;
}

export function IntegrationSettingsFromJSON(json: any): IntegrationSettings {
    return IntegrationSettingsFromJSONTyped(json, false);
}

export function IntegrationSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'max_document_age_days': json['max_document_age_days'],
        'cprm_ignore_latest_document_date': json['cprm_ignore_latest_document_date'],
        'aida_download_joined_records': !exists(json, 'aida_download_joined_records') ? undefined : json['aida_download_joined_records'],
    };
}

export function IntegrationSettingsToJSON(value?: IntegrationSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'max_document_age_days': value.max_document_age_days,
        'cprm_ignore_latest_document_date': value.cprm_ignore_latest_document_date,
        'aida_download_joined_records': value.aida_download_joined_records,
    };
}

